const associations = [
  { value: 'TASA', label: 'TPB (TASA)' }
];

export default associations;



// WEBPACK FOOTER //
// ./src/constants/associations.js